import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { map, first, filter, tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { LgvModel } from '../../data-models/longevity.model';
import { LgvSettingsService, LgvUserService } from '../../core/core.module';
import { EmailPopup } from '../email-popup/email-popup.component';
import { LgvCompanyService } from '../../core/services/lgv-company.service';

@Component({
    selector: 'lus-agent-card',
    templateUrl: 'agent-card.component.html',
    styleUrls: ['./agent-card.component.scss']
})

export class AgentCard implements OnInit {

    //get IsRealtor$(): Observable<boolean> {
    //    return this.Company$.pipe(
    //        map(obj =>
    //            obj.IsRealtor));
    //}

    _IsRealtor: boolean = false;
    IsRealtor$ = new BehaviorSubject(this._IsRealtor);

    AgentDTO$: Observable<LgvModel.AgentDTO>;
    agentCompanyCode: string = null;

    get agentCompany$(): Observable<LgvModel.CompanyInfo> { return this.lgvCompanySvc.getCachedCompanyByCode(this.agentCompanyCode);  }

    _agentCompanyBranding: LgvModel.CompanyBranding = null;
    agentCompanyBranding$ = new BehaviorSubject(this._agentCompanyBranding);

    get showAllIn$(): Observable<boolean> { return this.lgvCompanySvc.activeCompanyCode$.pipe(map(m => m.toUpperCase() !== 'NFM' )); }

    @Input() ShowingTwoAgents: boolean = false;
    @Input() IsCoBrandedAgent: boolean = false;
    @Input() IsPublicZone: boolean = false;
    @Input() AgentDTOParam$: Observable<LgvModel.AgentDTO> = null;

    get AgentSafeURL$(): Observable<string> { return this.AgentDTO$.pipe(map(x => !(!!x.agentInfo?.website) ? '' : x.agentInfo.website.startsWith('www') ? '//' + x.agentInfo.website : x.agentInfo.website)); }

    constructor(
        public LgvUserSvc: LgvUserService,
        public lgvCompanySvc: LgvCompanyService,
        public SendEmailDialog: MatDialog,
        public LgvSettingsService: LgvSettingsService) { }

    ngOnInit() {
        if (this.AgentDTOParam$) {
            this.AgentDTO$ = this.AgentDTOParam$;
        }
        else {
            if (this.IsCoBrandedAgent === true) {
                this.AgentDTO$ = this.LgvUserSvc.CoBrandedAgentDTO$;
            }
            else {
                this.AgentDTO$ = this.LgvUserSvc.AgentDTO$;
            }
        }

        this.AgentDTO$.pipe(first(f => f !== null)).subscribe(x => {
            //console.log(`### Have AgentDTO - isCB: ${this.IsCoBrandedAgent} ###`);
            console.log(x);

            this.agentCompanyCode = x.company?.companyCode;
            this.lgvCompanySvc.getBrandingByCode(x.company?.companyCode).pipe(first(f => f !== null)).subscribe(b => {
                //console.log(`### Have Branding - isCB: ${this.IsCoBrandedAgent} ###`);
                //console.log(b);
                this.agentCompanyBranding$.next(b);
            });
        });


        this.IsRealtor$.next(this.ShowingTwoAgents && !this.IsCoBrandedAgent);
    }

    OnSendEmail(): void {
        const dialogRef = this.SendEmailDialog.open(EmailPopup, {
            width: '500px',
            data: { type: 'General' }
        });
    }

}
